<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-card
    :color="color"
    elevation="0"
    @click="showProductDetail({code:license.metadata.code})"
  >
    <v-responsive :aspect-ratio="1">
      <div
        class="d-flex align-center justify-center flex-column"
        style="height: 100%;position: relative"
      >
        <div
          class="px-12"
          style="width: 100%"
        >
          <v-img
            :aspect-ratio="1"
            :src="license.images[0]"
            :style="status !== 'active' ? '-webkit-filter: grayscale(100%);filter: grayscale(100%);' : ''"
            :width="'100%'"
          />
        </div>
        <div
          class="d-block overflow-hidden text-center mt-4 px-2"
          style="z-index: 1; width: 100%;"
        >
          <div class="text-truncate text-body-1">{{ license.name }}</div>
        </div>
      </div>
    </v-responsive>
  </v-card>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'LicenseCard',
  props: {
    license: {},
    status: {}
  },
  methods: {
    ...mapMutations(['showProductDetail'])
  },
  computed: {

    color () {
      return this.status === 'active' ? 'green lighten-5' : this.status === 'cancel' ? 'error lighten-4' : 'grey lighten-5'
    }
  }
}
</script>

<style scoped>

</style>
